import { IResource, ISchedule } from "@gettactic/api";
import { VirtualizedList } from "@cmp-src/data-display/VirtualizedList/VirtualizedList";
import { ResourceLabel } from "@cmp-src/labels/ResourceLabel/ResourceLabel";
import { MapFiltersCardSearchNoResults } from "@/features/map/components/MapFiltersCard/MapFiltersCardSearchNoResults";
import { MapFiltersCardClasses as classes } from "@/features/map/components/MapFiltersCard/MapFiltersCard";

export interface ResourceWithSchedules extends IResource {
  schedules?: ISchedule[];
}

export interface GetResourcesVirtualizedListTabOptions {
  value: string;
  label: string;
  resources: ResourceWithSchedules[];
  setResourceIdHovering: (resourceId: IResource | null) => void;
  onReserve: (resourceId: IResource | null) => void;
  searchText?: string;
  showSchedules?: boolean;
  showScheduleOfUserId?: string | undefined;
  floorName?: string;
}

export const getResourcesVirtualizedListTab = (
  options: GetResourcesVirtualizedListTabOptions
) => {
  const {
    value,
    label,
    resources,
    setResourceIdHovering,
    onReserve,
    searchText = "",
    showSchedules = false,
    showScheduleOfUserId,
    floorName
  } = options;

  const isOther = label === "Other";

  return {
    value,
    label,
    content: !resources.length ? (
      searchText.length > 0 ? (
        <MapFiltersCardSearchNoResults
          target={isOther ? "resources" : String(label).toLowerCase()}
          searchText={searchText}
          floorName={floorName}
        />
      ) : (
        <div className="text-center text-neutral-500 text-md">
          {getPlaceholderText(isOther ? "other resources" : label)}
        </div>
      )
    ) : (
      <VirtualizedList
        itemHeight={88}
        scrollAreaProps={{
          className: "!absolute inset-0"
        }}
      >
        {resources.map((resource) => {
          const schedules = showSchedules
            ? showScheduleOfUserId
              ? resource.schedules?.filter((schedule) => {
                  return schedule.slots?.some(
                    (slot) => slot.user?.id === showScheduleOfUserId
                  );
                })
              : resource.schedules
            : undefined;

          return (
            <ResourceLabel
              className={classes.ListItem}
              resource={resource}
              key={resource.id}
              onMouseEnter={() => {
                setResourceIdHovering(resource);
              }}
              onClick={() => onReserve(resource)}
              onMouseLeave={() => setResourceIdHovering(null)}
              schedules={schedules}
              showHierarchy={!schedules?.length}
            />
          );
        })}
      </VirtualizedList>
    ),
    className: classes.TabsContent
  };
};

export const getPlaceholderText = (contentType: string) => {
  return `No ${contentType} found on this floor for the selected date and time.`;
};
